import PropTypes from 'prop-types'

import AtomButton, {atomButtonColors, atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import {ATOM_ICON_COLORS, ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import AtomTooltip, {AtomTooltipPlacements} from '@s-ui/react-atom-tooltip'
import ShareWebOutline from '@adv-mt/mt-svg-icons/lib/ShareWebOutline'
import IconTriangleWarningOutline from '@adv-mt/mt-svg-icons/lib/TriangleWarningOutline'

import {NO_OP} from '../config.js'

const CardRatingActions = ({
  onClickReplyAction = NO_OP,
  onClickReportAction = NO_OP,
  replyActionDisabled = false,
  replyActionSelected = false,
  replyButtonLabel,
  reportButtonLabel
}) => {
  return (
    <div className="mt-CardRating-actions">
      <AtomTooltip
        className="mt-CardRating-replyTooltip"
        content={replyButtonLabel}
        placement={AtomTooltipPlacements.TOP}
        delay={0}
      >
        <AtomButton
          aria-label={replyButtonLabel}
          disabled={replyActionDisabled}
          onClick={onClickReplyAction}
          design={atomButtonDesigns.FLAT}
          isFitted
          shape={atomButtonShapes.CIRCULAR}
          focused={replyActionSelected}
          leftIcon={<ShareWebOutline size={ATOM_ICON_SIZES.medium} />}
        />
      </AtomTooltip>
      <AtomTooltip
        className="mt-CardRating-reportTooltip"
        content={reportButtonLabel}
        placement={AtomTooltipPlacements.TOP}
        delay={0}
      >
        <AtomButton
          aria-label={reportButtonLabel}
          design={atomButtonDesigns.FLAT}
          onClick={onClickReportAction}
          shape={atomButtonShapes.CIRCULAR}
          color={atomButtonColors.ERROR}
          leftIcon={<IconTriangleWarningOutline size={ATOM_ICON_SIZES.medium} color={ATOM_ICON_COLORS.error} />}
          isFitted
        />
      </AtomTooltip>
    </div>
  )
}

CardRatingActions.displayName = 'CardRatingActions'

CardRatingActions.propTypes = {
  onClickReplyAction: PropTypes.func,
  onClickReportAction: PropTypes.func,
  replyActionDisabled: PropTypes.bool,
  replyActionSelected: PropTypes.bool,
  replyButtonLabel: PropTypes.string,
  reportButtonLabel: PropTypes.string
}

export default CardRatingActions
